module["exports"] = [
  "چین",
  "هند",	
  "ایالات متحده آمریکا",
  "اندونزی",	
  "برزیل",	
  "بنگلادش",
  "روسیه",
  "ژاپن",
  "پاکستان",
  "ویتنام",
  "نیجریه",
  "مکزیک",
  "اتیوپی",
  "آلمان",
  "فیلیپین",	
  "تایلند",
  "جمهوری دموکراتیک کنگو",	
  "میانمار",
  "بریتانیا",
  "فرانسه",
  "ترکیه",
  "ایران",		
  "مصر",	
  "کره جنوبی",	
  "ایتالیا",	
  "تانزانیا",
  "کلمبیا",	
  "اسپانیا",
  "اوکراین",
  "کنیا",
  "کانادا",
  "آفریقای جنوبی",
  "لهستان",
  "اوگاندا",	
  "آرژانتین",
  "ازبکستان",
  "پرو",	
  "نپال",
  "ونزوئلا",
  "مالزی",	
  "کره شمالی",
  "استرالیا",
  "غنا",	
  "سودان",
  "مراکش",	
  "تایوان",
  "الجزایر",	
  "موزامبیک",
  "ماداگاسکار",		
  "رومانی",	 
  "قزاقستان",		 
  "آنگولا",	 
  "عراق",		 
  "سریلانکا",		 
  "کامرون",	 
  "عربستان سعودی",		 
  "شیلی", 
  "هلند",	 
  "ساحل عاج",		 
  "کامبوج",	 
  "افغانستان",		 
  "یمن",	 
  "اکوادور",		 
  "بورکینافاسو",		
  "زامبیا",	 
  "سنگال",		 
  "مالاوی",	 
  "گینه",	 
  "پرتغال",		 
  "جمهوری چک",		 
  "کوبا", 
  "بلژیک",		 
  "سوئد",	 
  "سوریه",		 
  "بلاروس",	
  "سوئیس",		 
  "بولیوی",	 
  "یونان", 
  "جمهوری دومینیکن",		 
  "هائیتی", 
  "نیجر",	
  "جمهوری آذربایجان",
  "امارات متحده عربی",		 
  "گواتمالا",
  "رواندا",	
  "چاد",	
  "مجارستان",		 
  "بوروندی",		
  "پاپوآ گینه نو",		 
  "تونس",	 
  "زیمبابوه",		 
  "هنگ کنگ",		 
  "اتریش", 
  "بنین",	 
  "هندوراس",		 
  "اسرائیل",		 
  "سومالی",		
  "سنگاپور",		 
  "لائوس",	 
  "مالی",	 
  "پاراگوئه",		 
  "نیکاراگوئه",		 
  "اریتره",	 
  "جمهوری کنگو",		 
  "دانمارک",	 
  "السالوادور",		 
  "اسلواکی",		 
  "نروژ",	 
  "فنلاند",		 
  "توگو",		
  "بلغارستان",		 
  "نیوزیلند",	 
  "کویت",	 
  "قرقیزستان",		
  "ترکمنستان",		 
  "کاستاریکا",		 
  "تاجیکستان",		 
  "سیرالئون",		 
  "جمهوری ایرلند",		 
  "جمهوری آفریقای مرکزی",		 
  "گرجستان", 
  "اردن",	 
  "کرواسی",		 
  "صربستان",		 
  "اروگوئه",	 
  "لیبی",	 
  "پاناما",		 
  "بوسنی و هرزگوین", 
  "لبنان",
  "لیتوانی",		 
  "قطر",	 
  "ارمنستان",		 
  "لیبریا",	
  "موریتانی",		
  "بوتسوانا",		 
  "پورتوریکو",		
  "جامائیکا",		 
  "مولداوی",		 
  "آلبانی",	 
  "مغولستان",		 
  "اردن",		 
  "لتونی",		 
  "عمان",		
  "جمهوری مقدونیه", 
  "اسلوونی",	 
  "نامیبیا",	 
  "لسوتو",		 
  "کوزوو",		 
  "گامبیا",		
  "بحرین",		 
  "استونی",		 
  "موریس",	 
  "گینه بیسائو",		
  "گابن",	 
  "ترینیداد و توباگو",		 
  "قبرس", 
  "اسواتینی",		 
  "تیمور شرقی",		
  "ماکائو",	 
  "نوار غزه",		 
  "پادشاهی بوتان",		
  "فیجی", 
  "گویان",		 
  "جیبوتی",		
  "مونتهنگرو",		 
  "کومور",	 
  "لوکزامبورگ",		 
  "برونئی",	 
  "جزایر سلیمان",		
  "باهاما", 
  "کیپ ورد",		
  "گینه استوایی",		
  "مالت", 
  "ایسلند",		 
  "سورینام",		
  "مالدیو",	
  "صحرای غربی",		 
  "باربادوس",	 
  "بلیز",	 
  "پلینزی فرانسه",
  "وانواتو",
  "کالدونیای جدید",	
  "سنت لوسیا",	
  "کوراسائو",		
  "گوآم", 
  "گرنادا",	 
  "سنت وینسنت و گرنادینها",		 
  "جرسی",
  "سائوتومه و پرنسیپ",		
  "موناکو",
  "آروبا",	 
  "جزایر ویرجین ایالات متحده",
  "ساموآ",
  "جزیره من",		
  "تونگا",	
  "سیشل",	
  "جزایر کیمن",		
  "جزایر ماریانای شمالی",		 
  "برمودا",
  "آندورا",	
  "لیختناشتاین",		
  "جزایر فارو",		
  "گرنزی",	
  "آنتیگوا و باربودا",		
  "گرینلند",
  "دومینیکا",	 
  "سنت مارتین",		 
  "سان مارینو",		
  "سنت کیتس و نویس",		
  "ساموای آمریکا",	
  "سنت مارتین",
  "ایالات فدرال میکرونزی",	
  "جزایر ویرجین انگلستان",		
  "جبل طارق",
  "جزایر مارشال",		 
  "پالائو",
  "کیریباتی",		
  "جزایر کوک",	
  "آنگویلا",	
  "جزایر فالکلند",		
  "جزایر تورکس و کایکوس",	 
  "مونتسرات",
  "تووالو",	 
  "سنت پیر و ماژلان",		
  "والیس و فوتونا",	
  "واتیکان",
  "سینت هلینا",		 
  "سوالبارد",		
  "جزیره نورفولک",	
  "نیووی",
  "توکلائو",		
  "جزایر پیتکرن"		
];
